import { createContext, useContext } from 'react';

// src/responsive/BreakpointContext.tsx
var BreakpointContext = createContext({
  matchedBreakpoints: []
});
function useBreakpointContext() {
  const context = useContext(BreakpointContext);
  return context;
}

export { BreakpointContext, useBreakpointContext };
